export enum DisplayFeedbackControlsEnum {
  TELEGRAM_AND_CONSULTATION = 'telegramAndConsultation',
  TELEGRAM = 'telegram',
  CONSULTATION = 'consultation'
}